import { http } from "../../lib/http";

/* -------------------------------- PAGOS ------------------------------- */
export const payments = {
  list: (params) => http.get("/admin/payments", { params }).then((r) => r.data),
};


/* ---------------------------- COMPROBANTES ---------------------------- */

/**
 * Comprobantes de entrega.
 *
 * Sin `create`: los emite el servidor cuando un pedido llega a "entregado". La
 * única escritura es anular, y eso deja constancia permanente.
 */
export const invoices = {
  list: (params) => http.get("/admin/invoices", { params }).then((r) => r.data),
  show: (id) => http.get(`/admin/invoices/${id}`).then((r) => r.data),

  /**
   * El PDF, como blob.
   *
   * No se puede poner la URL directamente en un `<a href>` ni en un `<iframe>`:
   * el endpoint pide el token en la cabecera y el navegador no lo manda en una
   * navegación. Se descarga con axios y se crea una URL local.
   */
  pdf: (id) =>
    http
      .get(`/admin/invoices/${id}/pdf`, { responseType: "blob" })
      .then((r) => r.data),

  anular: (id, motivo) =>
    http.put(`/admin/invoices/${id}/anular`, { motivo }).then((r) => r.data),

  /**
   * Varios de una vez, con el mismo motivo.
   *
   * El error que lleva a anular casi nunca es de un solo comprobante: se
   * facturó dos veces el corte de un día, o un negocio subió mal sus precios
   * toda una tarde.
   */
  anularLote: (ids, motivo) =>
    http
      .put("/admin/invoices/anular-lote", { ids, motivo })
      .then((r) => r.data),

  /**
   * Emite el comprobante de las entregas que se quedaron sin él.
   *
   * No crea nada nuevo: solo actúa sobre pedidos ya entregados y es idempotente,
   * así que pulsarlo dos veces no puede duplicar un comprobante.
   *
   * Se le pasan los MISMOS filtros del listado para que emita exactamente el
   * conjunto que la pantalla está contando.
   */
  emitirPendientes: (params) =>
    http
      .post("/admin/invoices/emitir-pendientes", null, { params })
      .then((r) => r.data),
};


/* ------------------------------- EFECTIVO ----------------------------- */
/**
 * El dinero que los domiciliarios tienen encima.
 *
 * `balances` responde la pregunta que antes no se podía hacer: hasta ahora
 * entregar en efectivo marcaba el pedido como pagado y el dinero desaparecía
 * del sistema, así que nadie sabía cuánto debía nadie.
 *
 * Confirmar un depósito es lo ÚNICO que baja el saldo: declararlo desde la app
 * solo lo deja pendiente. Si declarar bastara, saldar la deuda sería cuestión
 * de escribir una referencia inventada.
 */
export const efectivo = {
  deposits: (params) =>
    http.get("/admin/cash-deposits", { params }).then((r) => r.data),
  balances: () => http.get("/admin/cash-balances").then((r) => r.data),
  resolve: (id, body) =>
    http.put(`/admin/cash-deposits/${id}`, body).then((r) => r.data),
};


export const settlements = {
  list: (params) =>
    http.get("/admin/settlements", { params }).then((r) => r.data),
  show: (id) => http.get(`/admin/settlements/${id}`).then((r) => r.data),
  /** Genera el corte del periodo. El servidor excluye lo ya liquidado. */
  generate: (body) => http.post("/admin/settlements", body).then((r) => r.data),
  update: (id, body) =>
    http.put(`/admin/settlements/${id}`, body).then((r) => r.data),
  remove: (id) => http.delete(`/admin/settlements/${id}`).then((r) => r.data),
};


/* ------------------------------- REPORTES ----------------------------- */
export const reports = {
  /** `kind`: financial | commercial | operational | businesses */
  get: (kind, params) =>
    http.get(`/admin/reports/${kind}`, { params }).then((r) => r.data),

  /**
   * De dónde sale una cifra: qué negocio aporta cuánto.
   *
   * Se manda la MISMA consulta que la pantalla, filtros incluidos. Si el
   * desglose no sumara lo que dice la tarjeta, sería peor que no tenerlo.
   */
  desglose: (params) =>
    http.get("/admin/reports-desglose", { params }).then((r) => r.data),

  /**
   * El libro de Excel multi-hoja, con el mismo periodo que la pantalla.
   *
   * Solo para financial, commercial y operational: son los tres que tienen
   * generador con hojas de detalle. `businesses` es una tabla y se lleva en CSV.
   */
  excel: (kind, params) =>
    http
      .get(`/admin/reports/${kind}/excel`, { params, responseType: "blob" })
      .then((r) => r.data),
};
